export type SentryEnvironment = 'development' | 'staging' | 'production';

type PublicEnv = Partial<Record<string, string | undefined>>;

const LOCAL_HOST_PATTERN = /^(localhost|127(?:\.\d{1,3}){3}|0\.0\.0\.0)$/i;
const DEV_HOST_PATTERN = /(^|[.-])dev(?=[.-]|$)/i;
const STAGING_HOST_PATTERN = /(^|[.-])(st|stage|staging)(?=[.-]|$)/i;

const getHostname = (value: string | undefined): string | undefined => {
  if (!value) return undefined;

  try {
    return new URL(value).hostname;
  } catch {
    const withoutProtocol = value.replace(/^[a-z]+:\/\//i, '');
    return withoutProtocol.split('/')[0]?.split(':')[0];
  }
};

const getSentryHostname = (env: PublicEnv): string | undefined =>
  getHostname(env.NEXT_PUBLIC_DOMAIN) ??
  getHostname(env.NEXT_PUBLIC_API_DOMAIN);

export const getSentryEnvironment = (
  env: PublicEnv = process.env,
): SentryEnvironment | undefined => {
  const hostname = getSentryHostname(env);

  if (!hostname) return undefined;
  if (LOCAL_HOST_PATTERN.test(hostname) || DEV_HOST_PATTERN.test(hostname)) {
    return 'development';
  }
  if (STAGING_HOST_PATTERN.test(hostname)) {
    return 'staging';
  }

  return 'production';
};

export const isSentryEnabled = (env: PublicEnv = process.env): boolean =>
  getSentryEnvironment(env) === 'production';
